







































































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import TeamForm from '@/components/teams/teams-form.vue';
import UiCnpjFormat from '@/components/UI/cnpj-format.vue';
import * as service from '@/services/teams';
import TeamModel from '@/models/team-model';
import { filterByText } from '@/helpers/filterByText';
import { resetModalScroll } from '@/helpers/resetModalScroll';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    TeamForm,
    UiSelectClients,
    UiCnpjFormat,
    UiAutocompleClientsSubsidiaries,
  },
})
export default class Teams extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filter: any = {
    term: '',
    status: null,
    unidade: null,
  };

  public statusList: any[] = [
    {
      value: null,
      label: 'Todos',
    },
    {
      value: true,
      label: 'Ativo',
    },
    {
      value: false,
      label: 'Inativo',
    },
  ];

  public $refs!: {
    form: HTMLFormElement;
  };

  public headers: any = [
    { text: 'Cliente', value: 'unidade.nome' },
    { text: 'Nome', value: 'nome' },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];
  public data: TeamModel[] = [];
  public item: TeamModel = new TeamModel();

  public beforeMount(): void {
    this.load();
  }

  public onFilter(): void {
    this.load();
  }

  public onEditItem(item: TeamModel): void {
    this.loader.start('Carregando item...');
    service.getTeam(item.id).subscribe(
      (data) => {
        this.item = new TeamModel(data);
        this.formOpen = true;
        this.formOpen = true;
        this.loader.stop();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
      },
    );
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = search.toString().toLowerCase();
    return items.filter((row) => {
      return (
        filterByText(row, ['nome'], searchLower) ||
        filterByText(row.unidade, ['nome'], searchLower)
      );
    });
  }

  public saveItem(item: TeamModel): void {
    this.closeForm();
    this.load();
  }

  public toggleItemStatus(item: TeamModel, status: boolean): void {
    this.loader.start('Atualizando registro...');
    service.getTeam(item.id).subscribe((data) => {
      const _editableItem = new TeamModel(data);
      const payload = _editableItem.toTimeParmDTO();
      payload.ativo = status;
      service.updateTeam(payload).subscribe(
        () => {
          item.ativo = status;
          this.loader.stop();
        },
        () => {
          this.loader.stop();
          this.toast.show('Ocorreu um erro ao atualizar o time', 'error');
        },
      );
    });
  }

  public newItem(): void {
    this.item = new TeamModel();
    this.formIsEdit = false;
    this.formOpen = true;
  }

  public closeForm(): void {
    this.item = new TeamModel();
    this.formOpen = false;
    resetModalScroll();
  }

  private load(): void {
    this.data = [];
    this.loading = true;

    const filter = {
      unidade: this.filter.unidade ? this.filter.unidade.id : null,
      ativo: this.filter.status,
    };

    if (filter.unidade) {
      service.getTeamsByClient(filter.unidade, filter).subscribe(
        (data) => {
          this.data = data.map((item) => new TeamModel(item));
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.error = true;
        },
      );
    } else {
      service.getTeams(filter).subscribe(
        (data) => {
          this.data = data.map((item) => new TeamModel(item));
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.error = true;
        },
      );
    }
  }
}
